import base from '~base';
import initAttributes from './components/attributes';
import initProductNav from './components/productNav';
import initSizeChart from './components/sizeChart';
import initStockCheck from './components/stockCheck';
import videoPlayer from './components/videoPlayer';
import initReviews from './components/productReviews';
import deliveryReturns from './components/deliveryReturns';
import handleCarousel from './components/imageCarousel';
import { initImageGallery, imageCarousel } from './components/imageGallery';
import handleStickyComponents from './components/stickyComponents';
import handleProductCarousels from './components/productCarousels';
import handleProductSubscriptionForm from './components/backInStockSubscription';
import stickyBar from './components/stickyBar';
import handlePDPScroll from './components/handlePDPScroll';
import initPDPRecCarousel from './components/pdpRecomendationCarousel';

const handlePageElements = () => {
  initSizeChart();
  initStockCheck();
  initReviews();
  deliveryReturns();
  initAttributes();
  handleCarousel();
  initPDPRecCarousel();
  handleStickyComponents();
  handleProductCarousels();
  handleProductSubscriptionForm();

  const cldGalleryElement = document.getElementById('cld-gallery');
  if (!cldGalleryElement) {
    initImageGallery();
    imageCarousel();
  }
};

base.pageBehavior = () => {
  window.addEventListener('resize', handlePageElements);

  document.addEventListener('product:afterAttributeSelect', handlePageElements);

  initProductNav();
  handlePageElements();
};

base.stickyBar = () => {
  stickyBar();
  handlePDPScroll();
};

base.videoPlayer = () => {
  videoPlayer();
};
export default base;
